import React from "react"
import cal from "clsx"
import { useSelectWrap } from "./style"
interface ComponentProps {
    children: React.ReactNode,
}
export default (props: ComponentProps) => {
    const classes = useSelectWrap()
    const { children } = props
    return (
        <div className={cal(
            classes.selectLine,
            classes.weChatLine,
        )}>
            { children }
        </div>
    )
}

